/* Chaleura section library bridge: no page-shell replacement and no cart/add interception. */
(function () {
  'use strict';
  if (window.ChaleuraLibrary) return;
  let refreshing = null;
  const getCart = () => document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  async function refreshCart(options = {}) {
    if (refreshing) return refreshing;
    refreshing = (async () => {
      const cart = getCart();
      if (!cart || typeof cart.getSectionsToRender !== 'function') return null;
      const list = cart.getSectionsToRender();
      const url = new URL(window.routes?.cart_url || '/cart', window.location.origin);
      url.searchParams.set('sections', list.map(item => item.id).join(','));
      const response = await fetch(url.toString(), {headers: {'Accept': 'application/json'}});
      if (!response.ok) throw new Error('Unable to refresh cart (' + response.status + ')');
      const sections = await response.json();
      if (options.open === true && typeof cart.renderContents === 'function') {
        cart.renderContents({sections});
        return cart;
      }
      for (const section of list) {
        if (typeof sections[section.id] !== 'string') continue;
        const parsed = new DOMParser().parseFromString(sections[section.id], 'text/html');
        const selector = section.selector || '.shopify-section';
        const next = parsed.querySelector(selector);
        const target = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
        if (!next || !target) continue;
        if (section.id === 'cart-drawer' && typeof updateCartDrawer === 'function') {
          updateCartDrawer(target, next, false);
        } else target.innerHTML = next.innerHTML;
      }
      const overlay = cart.querySelector('#CartDrawer-Overlay');
      if (overlay && typeof cart.close === 'function' && !overlay.dataset.chCloseBound) {
        overlay.addEventListener('click', () => cart.close());
        overlay.dataset.chCloseBound = 'true';
      }
      return cart;
    })().finally(() => { refreshing = null; });
    return refreshing;
  }
  window.ChaleuraLibrary = {getCart, refreshCart};
  document.addEventListener('cart:refresh', event => {
    if (!document.querySelector('.ch-scope')) return;
    refreshCart({open: event.detail?.open === true}).catch(error => console.warn('[Chaleura sections]', error.message));
  });
  // Keep the two event buses independent except for explicitly marked cart updates.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' &&
      typeof ChSubscribe === 'function' && typeof CH_PUB_SUB_EVENTS !== 'undefined') {
    const relay = (target, eventName) => data => {
      if (data?.__chRelayed) return;
      target(eventName, Object.assign({}, data, {__chRelayed: true}));
    };
    subscribe(PUB_SUB_EVENTS.cartUpdate, relay(ChPublish, CH_PUB_SUB_EVENTS.cartUpdate));
    ChSubscribe(CH_PUB_SUB_EVENTS.cartUpdate, relay(publish, PUB_SUB_EVENTS.cartUpdate));
  }
  // The donor components expect template data but the Resorin shell remains unchanged.
  if (!document.body.dataset.sugarTemplate) {
    const meta = document.querySelector('meta[name="ch-template"]');
    if (meta) document.body.dataset.sugarTemplate = meta.content;
  }
})();
